window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};
/**
 * @fileOverview Contains utilities for the lpajax system - core and transports
 *
 * @author Efim Dimenstein
 * @version 0.1 - 2012-08-20
 */
/**
 * Contains utilities for the lpajax system - core and transports
 *
 * @namespace - contains the transport logic
 */
lpTag.taglets.lpajax_utils = {
    /**
     * The name of the object
     * @type String
     */
    _name : 'lpajax_utils',
    /**
     * The version of the object
     * @type String
     */
    _v : '0.1',
    /**
     * An `each` implementation, aka `forEach`<br>
     * Handles objects with the built-in `forEach`, arrays, and raw objects<br>
     * Delegates to **ECMAScript 5**'s native `forEach` if available
     *
     * @param {Object} obj list of elements
     * @param {Object} iterator
     * @param {Object} context
     * @example
     * lpTag.taglets.lpajax_utils.each([1, 2, 3], function(num){ alert(num); });
     * result: alerts each number in turn...
     * lpTag.taglets.lpajax_utils.each({one : 1, two : 2, three : 3}, function(num, key){ alert(num); });
     * result: alerts each number in turn...
     */
    each : function(obj, iterator, context) {
        if (obj == null) {return;}
        var nativeForEach = Array.prototype.forEach;

        if (nativeForEach && obj.forEach === nativeForEach) {
            obj.forEach(iterator, context);
        }
        else if (obj.length === +obj.length) {
            for (var i = 0, l = obj.length; i < l; i++) {
                if (i in obj && iterator.call(context, obj[i], i, obj) === {}) {return;}
            }
        } else {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    if (iterator.call(context, obj[key], key, obj) === {}) {return;}
                }
            }
        }
    },
    /**
     * Copy all of the properties in the source objects over to the destination object, and return the destination object.<br>
     * It's in-order, so the last source will override properties of the same name in previous arguments
     *
     * @param {Object} obj a request object (see lpAjax for detailed description)
     * @example
     * lpTag.taglets.lpajax_utils.extend(destination, *sources)
     * lpTag.taglets.lpajax_utils.extend({name : 'moe'}, {age : 50});
     * result: {name : 'moe', age : 50}
     */
    extend : function(obj) {
        this.each(Array.prototype.slice.call(arguments, 1), function(source) {
            for (var prop in source) {
                obj[prop] = source[prop];
            }
        });
        return obj;
    },
    /**
     * Method to check if object is empty<br>
     *
     * @param {Object} o any object
     * @returns true if object is empty and false otherwise
     * @example
     * lpTag.taglets.lpajax_utils.isEmptyObj({}) - return true
     * lpTag.taglets.lpajax_utils.isEmptyObj({name : 'moe'}); - return false
     */
    isEmptyObj: function( o ) {
        for (var n in o ) {
            return false;
        }
        return true;
    },

    init : function(){

    }
};
